import { render, staticRenderFns } from "./paramet02.vue?vue&type=template&id=4f04d38e&scoped=true&"
import script from "./paramet02.vue?vue&type=script&lang=js&"
export * from "./paramet02.vue?vue&type=script&lang=js&"
import style0 from "./paramet02.vue?vue&type=style&index=0&id=4f04d38e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f04d38e",
  null
  
)

export default component.exports